export function PrivacyPolicyNotice() {
  return null;
}
